var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1062_44882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 14.5H18.0001C15.8004 14.5 14.0002 16.3002 14.0002 18.4999V26.5001C14.0002 28.6993 15.8004 30.5 18.0001 30.5H26C28.1997 30.5 29.9999 28.6993 29.9999 26.5001V18.4999C29.9999 16.3002 28.1997 14.5 26 14.5ZM28.6665 26.5001C28.6665 27.9701 27.4707 29.1666 26 29.1666H18.0001C16.53 29.1666 15.3336 27.9701 15.3336 26.5001V18.4999C15.3336 17.0295 16.53 15.8334 18.0001 15.8334H26C27.4707 15.8334 28.6665 17.0295 28.6665 18.4999V26.5001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.334 19.1665C26.8862 19.1665 27.3339 18.7188 27.3339 18.1665C27.3339 17.6142 26.8862 17.1665 26.334 17.1665C25.7817 17.1665 25.334 17.6142 25.334 18.1665C25.334 18.7188 25.7817 19.1665 26.334 19.1665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 18.5C19.7903 18.5 18 20.2905 18 22.4999C18 24.7084 19.7903 26.5002 21.9999 26.5002C24.2088 26.5002 25.9998 24.7084 25.9998 22.4999C25.9998 20.2905 24.2088 18.5 21.9999 18.5ZM21.9999 25.1668C20.5273 25.1668 19.3334 23.9729 19.3334 22.4999C19.3334 21.0269 20.5273 19.8334 21.9999 19.8334C23.4725 19.8334 24.6664 21.0269 24.6664 22.4999C24.6664 23.9729 23.4725 25.1668 21.9999 25.1668Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 43,
    height: 43,
    rx: 11.5,
    stroke: "#E2E4E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1062_44882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(14 14.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8fdd3a922fa2b993bf7398ecc0feba30.svg";
export { ForwardRef as ReactComponent };